const homePageEvents = {
  FETCH_HOME_PAGE_DATA_PROGRESS: 'homePage/fetch_data_progress',
  FETCH_HOME_PAGE_DATA_SUCCESS: 'homePage/fetch_data_success',
  FETCH_HOME_PAGE_DATA_NOT_FOUND: 'homePage/fetch_data_not_found',
  FETCH_HOME_PAGE_DATA_FAILED: 'homePage/fetch_data_failed',
};
export default homePageEvents;
